"use client";

import dynamic from "next/dynamic";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { CartProvider, useCart } from "@/context/CartContext";
import Preloader from "@/components/Preloader";
import CatalogFocusRevalidator from "@/components/CatalogFocusRevalidator";

const MiniCart = dynamic(() => import("@/components/MiniCart"), { ssr: false });

function MiniCartSlot() {
  const { miniOpen } = useCart();

  return miniOpen ? <MiniCart /> : null;
}

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <CartProvider>
      <TooltipProvider>
        <CatalogFocusRevalidator />
        <Preloader />
        <MiniCartSlot />
        {children}
        <Sonner />
      </TooltipProvider>
    </CartProvider>
  );
}
